import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/Login";
import ForgotPasswordPage from "@/pages/ForgotPassword";
import ForcePasswordChangePage from "@/pages/ForcePasswordChange";
import DashboardPage from "@/pages/Dashboard";
import UsersPage from "@/pages/Users";
import RolesPage from "@/pages/Roles";
import AuditLogsPage from "@/pages/AuditLogs";
import MasterDataPage from "@/pages/MasterData";
import ProfilePage from "@/pages/Profile";
import VesselsPage from "@/pages/Vessels";
import VesselDetailPage from "@/pages/VesselDetail";
import NotFoundPage from "@/pages/NotFound";
import ExpiryBoardPage from "@/pages/ExpiryBoard";
import DailyReportPage from "@/pages/DailyReport";
import SeaContractsPage from "@/pages/SeaContracts";
import SeaTemplatesPage from "@/pages/SeaTemplates";
import CandidatesPage from "@/pages/Candidates";
import CandidateProfilePage from "@/pages/CandidateProfile";
import PipelinePage from "@/pages/Pipeline";
import RequirementsPage from "@/pages/Requirements";
import RequirementDetailPage from "@/pages/RequirementDetail";
import DevLoginsPage from "@/pages/DevLogins";
import "@/App.css";

function Protected({ children, permission }) {
  return (
    <ProtectedRoute requiredPermission={permission}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dev-logins" element={<DevLoginsPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route
              path="/force-password-change"
              element={
                <ProtectedRoute>
                  <ForcePasswordChangePage />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Protected><DashboardPage /></Protected>} />
            <Route path="/users" element={<Protected permission="users.view"><UsersPage /></Protected>} />
            <Route path="/roles" element={<Protected permission="roles.view"><RolesPage /></Protected>} />
            <Route path="/daily-report" element={<Protected><DailyReportPage /></Protected>} />
            <Route path="/expiry-board" element={<Protected permission="documents.view"><ExpiryBoardPage /></Protected>} />
            <Route path="/sea-contracts" element={<Protected permission="contracts.view"><SeaContractsPage /></Protected>} />
            <Route path="/settings/sea-templates" element={<Protected permission="roles.manage"><SeaTemplatesPage /></Protected>} />
            <Route path="/candidates" element={<Protected><CandidatesPage /></Protected>} />
            <Route path="/docs-queue" element={<Protected><CandidatesPage queue /></Protected>} />
            <Route path="/candidates/:id" element={<Protected><CandidateProfilePage /></Protected>} />
            <Route path="/pipeline" element={<Protected><PipelinePage /></Protected>} />
            <Route path="/requirements" element={<Protected><RequirementsPage /></Protected>} />
            <Route path="/requirements/:id" element={<Protected><RequirementDetailPage /></Protected>} />
            <Route path="/audit-logs" element={<Protected permission="audit.view"><AuditLogsPage /></Protected>} />
            <Route path="/master-data" element={<Protected permission="master_data.view"><MasterDataPage /></Protected>} />
            <Route path="/vessels" element={<Protected permission="vessels.view"><VesselsPage /></Protected>} />
            <Route path="/vessels/:id" element={<Protected permission="vessels.view"><VesselDetailPage /></Protected>} />
            <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
            <Route path="*" element={<Protected><NotFoundPage /></Protected>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
